/* rt: sombra por cima do rodapé do cart drawer enquanto a lista (.drawer__body) ainda tem conteúdo
   por baixo dele. Só põe/tira a classe rt-foot-has-more; o desenho está no rt-cart-drawer.css e a
   força na secção Cart drawer (--rt-foot-shadow).
   Sem MutationObserver: o contador de reserva muda texto a cada segundo e obrigava a ler o layout
   mesmo com o drawer fechado. O ResizeObserver dos blocos já apanha linhas e recomendados novos. */
(function () {
  if (window.rtCartFootShadow) return;
  window.rtCartFootShadow = true;

  let pending = false;
  function check() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      const body = document.querySelector('.drawer--cart .drawer__body');
      // com a faixa «Above the cart footer» a sombra fica em cima dela, que é o que está colado à lista
      const foot = document.querySelector('.drawer--cart .rt-cart-above-foot, .drawer--cart .drawer__foot');
      if (!body || !foot) return;
      foot.classList.toggle('rt-foot-has-more', body.scrollTop + body.clientHeight < body.scrollHeight - 2);
    });
  }

  function bind() {
    const body = document.querySelector('.drawer--cart .drawer__body');
    if (!body || body.dataset.rtFootShadow) return;
    body.dataset.rtFootShadow = '1';
    body.addEventListener('scroll', check, { passive: true });
    // o corpo muda de altura (resize, drawer a abrir) e os blocos crescem/encolhem (linhas por AJAX,
    // recomendados, fotos que carregam depois)
    if (window.ResizeObserver) {
      const ro = new ResizeObserver(check);
      ro.observe(body);
      Array.from(body.children).forEach((c) => ro.observe(c));
    } else {
      window.addEventListener('resize', check, { passive: true });
    }
    check();
  }

  document.addEventListener('theme:cart-drawer:open', () => { bind(); check(); });
  document.addEventListener('theme:cart:change', () => { bind(); check(); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
